import { render, staticRenderFns } from "./nothing.vue?vue&type=template&id=043624e4"
import script from "./nothing.vue?vue&type=script&lang=js"
export * from "./nothing.vue?vue&type=script&lang=js"
import style0 from "./nothing.vue?vue&type=style&index=0&id=043624e4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports